import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProductFeatureFlagsService } from 'src/app/services/product-feature-flags.service';
import { timeout } from 'rxjs';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  role: any = localStorage.getItem('role');
  id: any = localStorage.getItem('id');
  storeForm: any;
  storeData: any;
  userData: any;
  userVisitData: any;
  update: any;
  imagePath: string = environment.imageUrl;
  page: any = 1;
  word: any = '';
  ManagerStoreData: any;
  ManagerUserData: any;
  managerId: any = localStorage.getItem('managerId');
  loginToggleValue: boolean = false;
  signupToggleValue: boolean = false;
  signupSmsValidationToggleValue: boolean = false;
  signupEmailValidationToggleValue: boolean = false;
  productAllergensEnabledToggleValue: boolean = false;
  productNutritionEnabledToggleValue: boolean = false;
  radius: any;
  timeout: any = null;
  storeVisitstotal: any;

  minAppVersionAndroid: string = '';
  minAppVersionIOS: string = '';
  latestAppVersionAndroid: string = '';
  latestAppVersionIOS: string = '';
  forceUpdateMessage: string = '';

  readonly versionPattern = /^\d+\.\d+\.\d+$/;
  appVersionErrors: {
    minAppVersionAndroid?: string;
    minAppVersionIOS?: string;
    latestAppVersionAndroid?: string;
    latestAppVersionIOS?: string;
  } = {};

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public route: ActivatedRoute,
    public router: Router,
    public service: ApiService,
    public spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private productFeatureFlagsService: ProductFeatureFlagsService
  ) {}
  
  ngOnInit(): void {
    if (this.role === 'chain_manager') {
      this.router.navigate(['/my-chains']);
      return;
    }
    this.inputData = this.id;
    if (this.role == 'admin') {
      this.getStoreData();
      this.getUserData();
      this.getUserVisitData();
      this.getLoginSetting();
    } else {
      // this.getUserVisit()
      this.getManagerStoreData();
      this.getManagerUserVisitData();
    }

    // this.processAndSetRoundedImage(this.Image);
    // if (this.id !== 'null') {
    //   this.getStoreById()
    // }
  }

  toggle() {
    this.spinner.show();
    let body = {
      emailLogin: this.loginToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe(
      (res: any) => {
        if (res.response.data.emailLogin == true) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      (err) => {
        this.toastr.error(err.response.message);
        this.spinner.hide();
      }
    );
  }
  signupToggle() {
    this.spinner.show();
    let body = {
      emailSignUp: this.signupToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe(
      (res: any) => {
        if (res.response.data.emailSignUp == true) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      (err) => {
        this.toastr.error(err.response.message);
        this.spinner.hide();
      }
    );
  }

  signupSmsValidationToggle(): void {
    this.spinner.show();
    const body = {
      signupSmsValidation: this.signupSmsValidationToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe({
      next: (res: any) => {
        const enabled = res.response.data.signupSmsValidation === true;
        this.signupSmsValidationToggleValue = enabled;
        if (enabled) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.signupSmsValidationToggleValue = !this.signupSmsValidationToggleValue;
        this.toastr.error(err.error?.response?.message || err.response?.message);
        this.spinner.hide();
      },
    });
  }

  signupEmailValidationToggle(): void {
    this.spinner.show();
    const body = {
      signupEmailValidation: this.signupEmailValidationToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe({
      next: (res: any) => {
        const enabled = res.response.data.signupEmailValidation === true;
        this.signupEmailValidationToggleValue = enabled;
        if (enabled) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.signupEmailValidationToggleValue = !this.signupEmailValidationToggleValue;
        this.toastr.error(err.error?.response?.message || err.response?.message);
        this.spinner.hide();
      },
    });
  }

  productAllergensEnabledToggle(): void {
    this.spinner.show();
    const body = {
      productAllergensEnabled: this.productAllergensEnabledToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe({
      next: (res: any) => {
        const enabled = res.response.data.productAllergensEnabled === true;
        this.productAllergensEnabledToggleValue = enabled;
        this.productFeatureFlagsService.refresh();
        if (enabled) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.productAllergensEnabledToggleValue = !this.productAllergensEnabledToggleValue;
        this.toastr.error(err.error?.response?.message || err.response?.message);
        this.spinner.hide();
      },
    });
  }

  productNutritionEnabledToggle(): void {
    this.spinner.show();
    const body = {
      productNutritionEnabled: this.productNutritionEnabledToggleValue,
    };
    this.service.postRequest(ApiUrl.setting, body).subscribe({
      next: (res: any) => {
        const enabled = res.response.data.productNutritionEnabled === true;
        this.productNutritionEnabledToggleValue = enabled;
        this.productFeatureFlagsService.refresh();
        if (enabled) {
          this.toastr.success('Enabled Successfully');
        } else {
          this.toastr.success('Disabled Successfully');
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.productNutritionEnabledToggleValue = !this.productNutritionEnabledToggleValue;
        this.toastr.error(err.error?.response?.message || err.response?.message);
        this.spinner.hide();
      },
    });
  }

  enterRadius() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      let body = {
        radius: this.radius,
      };
      this.service.postRequest(ApiUrl.storeRadius, body).subscribe(() => {});
    }, 1000);
  }
  getLoginSetting() {
    this.service.getRequest(ApiUrl.getSetting).subscribe((res: any) => {
      const data = res.response.data;
      this.loginToggleValue = data.emailLogin;
      this.signupToggleValue = data.emailSignUp;
      this.signupSmsValidationToggleValue = data.signupSmsValidation === true;
      this.signupEmailValidationToggleValue = data.signupEmailValidation === true;
      this.productAllergensEnabledToggleValue = data.productAllergensEnabled === true;
      this.productNutritionEnabledToggleValue = data.productNutritionEnabled === true;
      this.radius = data.radius;
      this.minAppVersionAndroid = data.minAppVersionAndroid ?? '';
      this.minAppVersionIOS = data.minAppVersionIOS ?? '';
      this.latestAppVersionAndroid = data.latestAppVersionAndroid ?? '';
      this.latestAppVersionIOS = data.latestAppVersionIOS ?? '';
      this.forceUpdateMessage = data.forceUpdateMessage ?? '';
    });
  }

  private normalizeVersionValue(value: string): string | null {
    const trimmed = (value ?? '').trim();
    return trimmed.length ? trimmed : null;
  }

  validateAppVersionField(
    field:
      | 'minAppVersionAndroid'
      | 'minAppVersionIOS'
      | 'latestAppVersionAndroid'
      | 'latestAppVersionIOS'
  ): boolean {
    const value = this[field];
    const trimmed = (value ?? '').trim();

    if (!trimmed) {
      delete this.appVersionErrors[field];
      return true;
    }

    if (!this.versionPattern.test(trimmed)) {
      this.appVersionErrors[field] = 'Version must be in x.y.z format (e.g. 1.1.1)';
      return false;
    }

    delete this.appVersionErrors[field];
    return true;
  }

  validateAppVersionSettings(): boolean {
    const fields = [
      'minAppVersionAndroid',
      'minAppVersionIOS',
      'latestAppVersionAndroid',
      'latestAppVersionIOS',
    ] as const;

    return fields.every((field) => this.validateAppVersionField(field));
  }

  saveAppVersionSettings(): void {
    if (!this.validateAppVersionSettings()) {
      this.toastr.error('Fix version format errors before saving');
      return;
    }

    this.spinner.show();
    const body = {
      minAppVersionAndroid: this.normalizeVersionValue(this.minAppVersionAndroid),
      minAppVersionIOS: this.normalizeVersionValue(this.minAppVersionIOS),
      latestAppVersionAndroid: this.normalizeVersionValue(this.latestAppVersionAndroid),
      latestAppVersionIOS: this.normalizeVersionValue(this.latestAppVersionIOS),
      forceUpdateMessage: this.normalizeVersionValue(this.forceUpdateMessage),
    };

    this.service.postRequest(ApiUrl.setting, body).subscribe({
      next: () => {
        this.toastr.success('App version settings saved');
        this.spinner.hide();
      },
      error: (err) => {
        this.toastr.error(err.error?.response?.message || 'Failed to save app version settings');
        this.spinner.hide();
      },
    });
  }

  get hasAppVersionValidationErrors(): boolean {
    return Object.keys(this.appVersionErrors).length > 0;
  }

  getUserVisit() {
    this.service
      .getRequest(
        `${ApiUrl.getUserVisit}/${this.managerId}` + `?page=` + this.page
      )
      .subscribe((res: any) => {
        // console.log(res, "datawithid......")
        this.userVisitData = res.response?.data;
      });
  }

  getManagerStoreData() {
    this.spinner.show();
    this.service
      .getRequest(
        `${ApiUrl.storeListById}${this.managerId}` +
          `?page=` +
          this.page +
          `&word=` +
          this.word
      )
      .subscribe({
        next: (res: any) => {
          this.ManagerStoreData = res.response?.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  getManagerUserVisitData() {
    this.spinner.show();
    this.service
      .getRequest(
        `${ApiUrl.getUserVisitById}${this.managerId}` +
          `?page=` +
          this.page +
          `&word=` +
          this.word
      )
      .subscribe({
        next: (res: any) => {
          this.ManagerUserData = res.response?.data.visits;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  // getStoreById() {
  //   this.service.getRequest(`${ApiUrl.storeListById}/${this.id}`).subscribe((res: any) => {
  //     this.storeData = res.response?.data
  //     // console.log(this.storeData, "storedata")
  //   })
  // }

  getStoreData() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.storeList).subscribe(
      (res: any) => {
        this.storeData = res.response?.data?.storeCount;
        // console.log(this.storeData, "storedata")
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  getUserData() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getUserList).subscribe(
      (res: any) => {
        // console.log(res, "dashboard")
        this.userData = res.response?.data?.userCount;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  getUserVisitData() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.getUserVisit).subscribe(
      (res: any) => {
        // console.log(res, "dashboard")
        this.userVisitData = res.response?.data?.userVisitDataCount;
        this.storeVisitstotal = res.response.data.storeVisitsCount;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
  inputData: any = localStorage.getItem('id');
 
}
